module.exports = __webpack_public_path__ + "img/仙鹤草.89378606.jpg";